import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type { PostAppGroupIdBrazeDocsLookupResult } from "./types";

export const isPostAppGroupIdBrazeDocsLookupResult = objectOf<PostAppGroupIdBrazeDocsLookupResult>({
  results: string,
});
